import React from 'react'
import { Div, Flex, Text } from '@sendoutcards/quantum-design-ui'
import { Icon } from 'src/design_system/atoms/icons/components/Icon'
import { IconType } from 'src/design_system/atoms/icons/types'
import HoverTooltip from 'src/chrome/HoverTooltip/HoverTooltip'

type MembershipRewardsProps = {
  amount?: number
  icon?: IconType
  onClick?: () => void
  tooltipTitle?: string
}

const NAV_PILL_HEIGHT = '62px'
const REWARDS_ICON_SIZE = 30

export const MembershipRewards: React.FC<MembershipRewardsProps> = ({
  amount = 0,
  icon = 'reward_coin',
  onClick,
  tooltipTitle = 'Membership Rewards',
}) => {
  const formattedAmount = Math.max(amount, 0).toLocaleString()

  return (
    <HoverTooltip
      title={tooltipTitle}
      shouldDisplayTooltip={true}
      tooltipDirection="top"
      positioning={{ top: '115%' }}
    >
      <Flex
        justifyContent="center"
        alignItems="center"
        backgroundColor="#f5f6f7"
        inset={{ horizontal: 'x1' }}
        height={NAV_PILL_HEIGHT}
        style={{ borderRadius: '100px' }}
      >
        <Div
          boxShadow={'mediumLight'}
          inset={{ left: 'x2', right: 'x2_5' }}
          borderRadius="100px"
          backgroundColor={'foreground'}
          display="flex"
          alignItems="center"
          flexDirection="row"
          cursor={onClick ? 'pointer' : undefined}
          onClick={onClick}
          height="45px"
          columnGap="x1"
        >
          <Icon name={icon} size={REWARDS_ICON_SIZE} />
          <Text
            type="caption"
            weight="semiBold"
            color="primaryHeading"
            content={formattedAmount}
          />
        </Div>
      </Flex>
    </HoverTooltip>
  )
}

export default MembershipRewards
